// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".intelligent-booking-table {\n  height: 100%;\n}\n.intelligent-booking-table ul {\n    list-style-type: none;\n    padding-left: 0;\n}\n.intelligent-booking-table ul li {\n      padding: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
